export default {
  menuOpen: state => state.menuOpen,
  dropdownOpen: state => state.dropdownOpen,
  sectionOpen: state => state.sectionOpen,
}
